import React, { CSSProperties, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import {
    fetchSingleApp, createSentimentData, fetchSentimentData, fetchIndividualSentimentDetails,
    fetchNumberCount, fetchNumberBase, fetchActiveMasksByTenant, fetchSettlementTyps, updateSentimentStatus
} from '../../../store/actions';
import { useAppDispatch } from '../../../store';
import ScaleLoader from "react-spinners/ScaleLoader";
import { css } from '@emotion/react';
import AuthHandler from '../../../helper/AuthHandler';
import TableIcon from '../../../assets/images/icons/app-media-placeholder.svg';
import { PageHeaderStatic } from "../components/PageHeaderStatic";
import moment from "moment";
import NoData from "../../settings/components/NoData";
import { confirmAlert } from "react-confirm-alert";
import { Divider, Steps, notification, DatePicker, Modal, Space, Spin, Switch } from "antd";
import { Window } from "react-bootstrap-icons";
import dayjs from 'dayjs';
import { NumberbaseInput } from "./components/number-base-input.component";

import SimpleReactValidator from 'simple-react-validator';
import userStore from "../../../store/reducers/user.store";
import { NewSentimentData } from "./models/new-sentiment-data.model";
import * as CONSTANTS from '../../../constants';
import { Table } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import sentimentStore from '../../../store/reducers/sentiment.store';

const { RangePicker } = DatePicker;

const override: CSSProperties = {
    display: "block",
    margin: "0 auto"
};

const AddNewSentiment = ({ auth }: any) => {

    const { wid } = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [screen, setScreen] = useState('add-new-sentiment');
    const [enterpriseName, setEnterpriseName] = useState("");
    const [sentimentName, setSentimentName] = useState("");
    const [scheduleType, setScheduleType] = useState("now");
    const [date, setDate] = useState('');
    const [fieldDisabled, setFieldDisabled] = useState(false);
    const [dateRange, setDateRange] = useState<any[]>([]);
    const [sentimentNumberBase, setSentimentNumberBase] = useState("NEW_NUMBER_BASE");
    const [newNumberBase, setNewNumberBase] = useState("NEW_NUMBER_BASE");
    const [numberBaseName, setNumberBaseName] = useState("");
    const [existingNumberBaseDisabled, setExistingNumberBaseDisabled] = useState(false);
    const [newNumberBaseDisabled, setNewNumberBaseDisabled] = useState(false);
    const [numberBaseNameDisabled, setNumberBaseNameDisabled] = useState(false);
    const [numberBaseLabel, setNumberBaseLabel] = useState("Select CSV");
    const [existingNumberBase, setExistingNumberBase] = useState("EXISTING_NUMBER_BASE");
    const [inputLoading, setInputLoading] = useState(false);
    const [numberBaseError, setNumberBaseError] = useState("");
    const [dropdownSelected, setDropdownSelected] = useState(false);
    const [tenantNumberBases, setTenantNumberBases] = useState([]);
    const [seletedMask, setSeletedMask] = useState("");
    const [question, setQuestion] = useState("");
    const [questionLength, setQuestionLength] = useState(0);
    const [questionListError, setQuestionListError] = useState("");
    const [termsAndConditions, setTermsAndConditions] = useState<boolean>(false);
    const [tncError, setTncError] = useState('');
    const [showTnC, setShowTnC] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
    const [numberListLength, setNumberListLength] = useState<number>(0);
    const [maskList, setMaskList] = useState([]);
    const [saveSuccess, setSaveSuccess] = useState<boolean>(false)
    const [saveError, setSaveError] = useState<boolean>(false)
    const [saveLoading, setSaveLoading] = useState<boolean>(false);
    const [settlementTypes, setSettlementTypes] = useState([]);
    const [paymentMethodId, setPaymentMethodId] = useState<number>(0);
    const [enterpriseOwnerNumber, setEnterpiseOwnerNumber] = useState("");
    const [chargingNumber, setChargingNumber] = useState("");
    const [formSubmitted, setFormSubmitted] = useState<boolean>(false);
    const [isView, setIsView] = useState<boolean>(false);
    const [sentimentStatus, setSentimentStatus] = useState<string>("");
    const [statusValue, setStatusValue] = useState<string>("");
    const [submitUpdate, setSubmitUpdate] = useState<boolean>(true)
    const [newSentimentData, setNewSentimentData] = useState<NewSentimentData>({
        tenantId: "",
        smsMask: "",
        startTime: new Date(),
        endTime: '',
        questionList: [],
        numberBase: [],
        existingNumberBase: '',
        payment: {
            costAmount: "",
            taxAmount: ""
        }
    });

    const { userDetails } = useSelector(({ user }: any) => user);
    const { singleAppDetails, numberList, activeMaskList } = useSelector(({ apps }: any) => apps);
    const { success, loading, error, sentimentList, createSentimentResponse, sentimentIndividualDetails, sentimentUpdateResponse } = useSelector(({ sentiment }: any) => sentiment);
    const { settlement_types } = useSelector(({ location }: any) => location);

    const routePath = window.location.pathname.split('/')[3];

    const useForceUpdate = () => {
        const [value, setValue] = useState(0);
        return () => setValue(value => value + 1);
    }

    const forceUpdate = useForceUpdate()

    const [validator] = useState(new SimpleReactValidator({
        messages: {
            required: 'You can’t keep this as empty',
            min: 'Minimum length is :min',
            max: 'Maximum length is :max',
        },
        validators: {
            all_mobiles: {
                message: 'The entered :attribute number is invalid.',
                rule: (val: any, params?: any, validator?: any): boolean => {
                    return validator.helpers.testRegex(val, /^[0]{1}[123456789]{2}\d{7}$/) && params.indexOf(val) === -1
                }
            },
            dialog: {
                message: 'The :attribute is invalid.',
                rule: (val: any, params?: any, validator?: any): boolean => {
                    return validator.helpers.testRegex(val, /^([0]{1}[7]{1}[764]{1}\d{7}|[7]{1}[764]{1}\d{7})$/) && params.indexOf(val) === -1
                }
            },
            reachCount: {
                message: 'The selected payment type/or the number will not be applicable for this lead request.',
                rule: (val: any, params?: any, validator?: any): boolean => !!(val && val <= 50000)
            },
            reachCost: {
                message: 'Value must be greater than zero.',
                rule: (val: any, params?: any, validator?: any): boolean => !!(val > 0)
            }
        },
        autoForceUpdate: this
    }));

    const [questionValidator] = useState(new SimpleReactValidator({
        messages: {
            required: 'You can’t keep this as empty',
            min: 'Minimum length is :min',
            max: 'Maximum length is :max',
            not_regex: 'Unicode characters are not allowed.'
        },
        autoForceUpdate: this
    }));

    const onSentimentNameChange = (e: any) => {
        setSentimentName(e.target.value);
        // validator.fieldValid('title');
        validator.showMessageFor('sentiment name');
    }

    const onChangeScheduleType = (e: any) => {
        setScheduleType(e.target.value);
    }

    const onChangeDate = (e: any) => {
        setDate(e);
        // setBtnEnableForResubmit();
    }

    const onChangeDateRange = (e: any) => {
        setDateRange(e);
        // setBtnEnableForResubmit();
    }

    const onSelectNumberBase = (e: any) => {
        console.log(e.target.value)
        setSentimentNumberBase(e.target.value);
        setNumberBaseName("");
        validator.hideMessageFor('Number base name');
    }

    const onNumberbaseNameChange = (e: any) => {
        setNumberBaseName(e.target.value);
        validator.showMessageFor('Number base name');
        forceUpdate();
    }

    const onSelectExistingNumberBase = (e: any) => {
        var sentimentData = newSentimentData;
        sentimentData.existingNumberBase = e.target.value;
        sentimentData.numberBase = [];

        setNewSentimentData(sentimentData);
        setNumberBaseError("");
        setDropdownSelected(true);
        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        dispatch(fetchNumberCount(tenantGUID, newSentimentData.existingNumberBase))

    }

    const onSelectMask = (e: any) => {
        setSeletedMask(e.target.value);
    }

    const renderMaskList = () => {
        if (Array.isArray(maskList)) {
            return (
                maskList.map((value: any, index: any) => {
                    return (
                        <option selected={value.isDefault} value={value.uuid}>{decodeURIComponent(value.mask)}</option>
                    );
                })
            )
        }
        return "";
    };

    const renderQuestionLabel = () => {
        if (newSentimentData && newSentimentData?.questionList?.length > 0) {
            return (
                <div>
                    <label htmlFor="scheduleTime">Added questions</label>
                    <br />
                </div>
            )
        }
    }

    const onDeleteQuestion = (index: any) => {
        let newSentimentDataObj = newSentimentData;
        newSentimentDataObj.questionList.splice(index, 1);
        setNewSentimentData(newSentimentDataObj);
        forceUpdate();
    }

    const renderOwnersNumber = () => {
        if (paymentMethodId == 1) {
            return (
                <div className="form-element__wrapper mb-3">
                    <label htmlFor="smsSenderName" style={{ paddingRight: '5px' }}>Enterprise owner's number</label>
                    {/* <Tooltip title={<p>Note: The charging number will be the selected number</p>}>
                        <InfoCircleOutlined style={{ color: "#555555" }} />
                    </Tooltip> */}
                    <input
                        type="text"
                        id="alertReceiving"
                        className="form-control form-control-md"
                        value={enterpriseOwnerNumber}
                        placeholder="charging number" readOnly />
                    <small className="validation invalid-feedback">{validator.message('charging number', chargingNumber, 'required')}</small>
                </div>
            )
        }
    }

    const renderQuestions = () => {
        return (
            <div>
                {routePath !== "sentiment-update" && <div className="form-element__wrapper mb-3">
                    <label htmlFor="" className="form-label">Enter sentiment questions</label>
                    <div className="inner-multiple-feature-list-element__mc-wrapper horizontal">
                        <div className=" mb-4" style={{ paddingLeft: '0px !important' }}>
                            <textarea
                                className="form-control"
                                id="sentimentQuestion"
                                // rows="8"
                                value={question}
                                onChange={onQuestionChange}
                                placeholder="How satisfied are you with your business?"
                            >
                            </textarea>
                            <div
                                className="validation invalid-feedback">{questionValidator.message('question', question, 'required|not_regex:[^\u0000-\u00ff]')}</div>
                        </div>
                        <div className="form-check mb-4">
                            <button type="button" className="btn btn-outline-primary waves-effect"
                                onClick={onAddQuestion}><i className="fas fa-plus ml-1"></i> Add
                                new
                            </button>
                        </div>
                    </div>
                </div>}
                <div className="form-element__wrapper mb-3">
                    {renderQuestionLabel()}
                    {newSentimentData?.questionList?.length === 0 &&
                        <label htmlFor="" className="form-label">No questions added yet.</label>
                    }
                    <div className="inner-multiple-feature-list-element__one-wrapper horizontal">
                        {newSentimentData && newSentimentData?.questionList?.length > 0 &&
                            <div className="section__wrapper">
                                <div className="card panel content-holder-panels">
                                    <div className="panel-table-listing__wrapper">
                                        {/* <Table
                                            className="gx-table-responsive"
                                            sortDirections={['descend', 'ascend']}
                                            showSorterTooltip={false}
                                            columns={[{
                                                title: "Question ID",
                                                dataIndex: "id",
                                                key: 'x',
                                                width: "20%",
                                                render: (id, record, index) => { ++index; return index; },
                                            }, {
                                                title: "Question",
                                                dataIndex: "question",
                                                key: 'x',
                                            }, {
                                                title: "",
                                                dataIndex: "action",
                                                fixed: 'right',
                                                width: "10%",
                                                render: (text, row, index) => <Space size={10}>
                                                    {
                                                        // <span onClick={() => onDeleteQuestion(row)}><i
                                                        //     className="bi bi-x-lg"></i></span>
                                                        <a><CloseOutlined onClick={() => onDeleteQuestion(index)} /></a>
                                                    }
                                                </Space>
                                            }]}
                                            dataSource={newSentimentData.questionList ? newSentimentData.questionList : []}
                                            pagination={false}
                                            size={"small"}
                                        /> */}
                                        <div className="table-parent__wrapper">
                                            <table className="table table-default">
                                                <tbody>
                                                    <tr>
                                                        <th className="txt-left">Question ID</th>
                                                        <th className="txt-left">Question</th>
                                                        <th className="txt-left"></th>
                                                    </tr>
                                                    {newSentimentData?.questionList?.map((obj, index) => {
                                                        return (
                                                            <tr className="table-row " key={index}>
                                                                <td className="txt-left" scope="row">{index + 1}</td>
                                                                <td className="txt-left" style={{ padding: "0px !important" }}>{obj.question}</td>
                                                                <td className="txt-left">
                                                                    <CloseOutlined onClick={() => onDeleteQuestion(index)} />
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <br />
                    <small className="validation invalid-feedback">{questionListError}</small>
                </div>
            </div >
        )
    }

    const onQuestionChange = (e: any) => {
        setQuestion(e.target.value);
    }

    const onAddQuestion = () => {
        if (questionValidator.fieldValid('question')) {
            let newQuestion = {
                question: '',
            };
            newQuestion.question = question;
            const newSentimentDataObj = newSentimentData;
            newSentimentDataObj.questionList.push(newQuestion);
            setNewSentimentData(newSentimentDataObj);
            setQuestion("");
            forceUpdate();
        } else {
            questionValidator.showMessageFor('question');
        }
    }

    const onConfirmationTerms = (e: any) => {
        setTermsAndConditions(e.target.checked);
        setTncError("")
    }

    const onShowTnC = () => {
        setShowTnC(true);
    }

    const renderSubmitButton = () => {
        if (AuthHandler.isPerformable(auth, "add-new-sentiment") && routePath !== "sentiment-update") {
            return (
                <Spin tip="" size="small" spinning={loading}>
                    <button onClick={handleWidgetSave} className="btn btn-primary" type="submit"
                        disabled={submitDisabled || loading}>Pay and Send</button>
                </Spin>
            )
        }
        if (AuthHandler.isPerformable(auth, "update-sentiment") && routePath == "sentiment-update") {
            return (
                <Spin tip="" size="small" spinning={loading}>
                    <button onClick={handleWidgetupdate} className="btn btn-primary" type="submit" disabled={submitUpdate || loading}>Update</button>
                </Spin>
            )
        }
    }

    const handleWidgetSave = async () => {
        let totalCost = 0;
        let finalCost;
        let startTime = null;
        let endTime = null;
        if (scheduleType === 'schedule') {
            startTime = dayjs(dateRange[0]).format("YYYY-MM-DD HH:mm:ss");
            endTime = dayjs(dateRange[1]).format("YYYY-MM-DD HH:mm:ss");
        } else {
            startTime = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
            endTime = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
        }
        if (singleAppDetails?.widgetDetails !== null) {
            let questionSepration = [];
            if (userDetails && userDetails.OwnedEnterprises[0].Enterprise !== null) {
                if (userDetails.OwnedEnterprises[0].Enterprise.status.toLowerCase() === 'active') {
                    totalCost = singleAppDetails?.widgetDetails !== null ? singleAppDetails?.widgetDetails.chargeAmount * numberListLength : 0;
                } else {
                    let numberListLengthdata;
                    if (numberListLength < 5) {
                        numberListLengthdata = numberListLength;
                    } else {
                        numberListLengthdata = 5;
                    }
                    totalCost = CONSTANTS.DEMO_COST * numberListLengthdata;
                }
            }
            finalCost = totalCost < 1 ? 'Rs ' + totalCost.toFixed(2) + ' (' + Math.floor(totalCost * 100) + ' cents)' : 'Rs ' + totalCost.toFixed(2);
            if (validator.fieldValid('end date') && validator.fieldValid('sentiment name') && newSentimentData.questionList.length !== 0 && ((newSentimentData.numberBase.length !== 0 && validator.fieldValid('Number base name')) || newSentimentData.existingNumberBase !== '')) {
                confirmAlert({
                    childrenElement: () => <div>
                        {/* <b className="model_special_text">Total cost for this sentiment
                        is {finalCost}</b><br /> */}
                        {CONSTANTS.SENTIMENT}</div>,
                    buttons: [
                        {
                            label: 'Yes',
                            onClick: () => onSubmitSentimentData()
                        },
                        {
                            label: 'No',
                        }
                    ]
                });
            } else {
                validator.showMessages();

                if (sentimentNumberBase === "NEW_NUMBER_BASE") {
                    validator.showMessageFor('Number base name');
                }

                setSaveSuccess(false);
                setSaveError(false);
                setSaveLoading(false);

                if (newSentimentData.numberBase.length === 0 && newSentimentData.existingNumberBase === '' && numberBaseError === '') {
                    setNumberBaseError('Please select a number base')
                }
                if (newSentimentData.questionList.length === 0) {
                    setQuestionListError('No questions added');
                }
            }
        }

    }

    const onSubmitSentimentData = () => {

        let questionListObj;
        let startTime = null;
        let endTime = null;
        if (singleAppDetails && singleAppDetails.widgetDetails) {
            questionListObj = newSentimentData.questionList;
        }

        if (scheduleType === 'schedule') {
            startTime = dayjs(dateRange[0]).format("YYYY-MM-DD HH:mm:ss");
            endTime = dayjs(dateRange[1]).format("YYYY-MM-DD HH:mm:ss");
        } else {
            startTime = dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss");
            endTime = dayjs(date).format("YYYY-MM-DD HH:mm:ss");
        }

        var submitData = {
            "isNewNumberBase": sentimentNumberBase === 'NEW_NUMBER_BASE' ? true : false,
            "numberBaseId": newSentimentData.existingNumberBase,
            "numberBaseName": numberBaseName,
            "sentimentOwnerNumber": enterpriseOwnerNumber,
            "numberBase": newSentimentData.numberBase,
            "sentimentName": sentimentName,
            "questionList": questionListObj,
            "startTime": startTime,
            "endTime": endTime,
            "mask": seletedMask
        };

        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";

        setFormSubmitted(true);
        if (singleAppDetails?.widgetDetails !== null) {
            dispatch(createSentimentData(submitData, tenantGUID, singleAppDetails?.widgetDetails.uuid));
        }
    }

    const handleWidgetupdate = () => {
        confirmAlert({
            message: CONSTANTS.SENTIMENT_UPDATE,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => onUpdateSentimentData()
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    const onUpdateSentimentData = () => {
        var submitData = {
            "status": sentimentStatus === "Inactive" ? "Stop" : statusValue,
            "expiredAt": dayjs(dateRange[1]).format("YYYY-MM-DD HH:mm:ss")
        };

        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        const configId = window.location.pathname.split('/')[CONSTANTS.BASEURLPATHLENGTH + 4];

        if (singleAppDetails?.widgetDetails !== null) {
            dispatch(updateSentimentStatus(tenantGUID, configId, submitData));
        }

    }

    const onHideTnC = () => {
        setShowTnC(false);
    }

    const onChangeStatus = (checked: any) => {
        setSentimentStatus(checked == true ? 'Active' : 'Inactive');
        setSubmitUpdate(false);
        forceUpdate()
    }

    useEffect(() => {
        if (sentimentIndividualDetails && sentimentIndividualDetails != null && routePath == "sentiment-update") {
            setSentimentName(sentimentIndividualDetails.sentimentTitle);
            setDateRange([dayjs(sentimentIndividualDetails.startTime), dayjs(sentimentIndividualDetails.endTime)])
            setScheduleType('schedule');
            setIsView(true);
            setNumberBaseName(sentimentIndividualDetails?.NumberBase?.numberBaseName);
            let newSentimentDataObj = newSentimentData;
            newSentimentDataObj.questionList = sentimentIndividualDetails?.SentimentDetails;
            setNewSentimentData(newSentimentDataObj);
            setSentimentStatus(sentimentIndividualDetails?.status);
            setStatusValue(sentimentIndividualDetails?.status)
        }
    }, [sentimentIndividualDetails])

    useEffect(() => {
        var list = JSON.parse(JSON.stringify(activeMaskList));
        if (Array.isArray(activeMaskList)) {
            list.forEach((element: any) => {
                if (element.isDefault = true) {
                    setSeletedMask(element.uuid);
                }
            });
        }
    }, [activeMaskList])

    useEffect(() => {
        if (createSentimentResponse && createSentimentResponse.statusCode == 200) {
            notification.success({
                message: `Success`,
                description: "New sentiment has been added successfully.",
                placement: 'topRight'
            });
            dispatch(sentimentStore.actions.sentimentDataPostSuccess(null));
            navigate(`/sentiment/${singleAppDetails?.widgetDetails.uuid}/list`);
        }

    }, [createSentimentResponse]);

    useEffect(() => {
        if (sentimentUpdateResponse && sentimentUpdateResponse.statusCode == 200) {
            notification.success({
                message: `Success`,
                description: "sentiment has been updated successfully.",
                placement: 'topRight'
            });
            dispatch(sentimentStore.actions.sentimentUpdateSuccess(null));
            navigate(`/sentiment/${singleAppDetails?.widgetDetails.uuid}/list`);
        }

    }, [sentimentUpdateResponse])

    useEffect(() => {
        setSettlementTypes(settlement_types);
        if (settlement_types) {
            setPaymentMethodId(settlement_types?.paymentMethodId);
        }
    }, [settlement_types])

    // useEffect(() => {
    //     console.log("newSentimentData", newSentimentData)
    // }, [newSentimentData])

    // useEffect(() => {
    //     setQuestion("");
    //     setQuestionListError("");
    //     setQuestionLength(0)

    // }, [newSentimentData])

    useEffect(() => {
        setQuestionLength(question.length)
        // questionValidator.showMessageFor('question');
    }, [question])

    useEffect(() => {
        const tenantGUID = (userDetails && userDetails.OwnedEnterprises[0]) ? userDetails.OwnedEnterprises[0].groupId : "";
        dispatch(fetchActiveMasksByTenant(tenantGUID));
        if (tenantGUID && singleAppDetails && singleAppDetails.widgetDetails) {
            dispatch(fetchNumberBase(tenantGUID, singleAppDetails?.widgetDetails?.uuid));
            dispatch(fetchSettlementTyps(tenantGUID, singleAppDetails?.widgetDetails?.uuid))
        }
        if (routePath == "sentiment-update") {
            const sentimentId = window.location.pathname.split('/')[4];
            dispatch(fetchIndividualSentimentDetails(tenantGUID, sentimentId))
        }
    }, [userDetails])

    useEffect(() => {
        setMaskList(activeMaskList);
    }, [activeMaskList])

    const onChangeFile = (data: any, fileInfo: any) => {
        const regexDialog = /^([764]{2}\d{7}|[0764]{3}\d{7})$/;
        const regexNumeric = /^\d+$/;
        var numberList = [];

        var numberBaseError = "";
        let numberObj = { "msisdn": "", "name": "" };

        var arrayData = data.map(function (value: any, index: any) {
            if (Array.isArray(value)) {
                if (value.length > 0) {
                    if (value[0] !== "") {
                        if (value.length === 2) {
                            numberList.push(value);
                            if (value[0].length < 31) {
                                if (value[1].length === 9 || value[1].length === 10) {
                                    numberObj = { "msisdn": "", "name": "" };
                                    numberObj.name = value[0];
                                    numberObj.msisdn = value[1].length === 10 ? value[1].substring(1, 10) : value[1];
                                } else {
                                    setNumberBaseError("Contains invalid mobile numbers. Please check and try again");
                                }
                            } else {
                                setNumberBaseError("Name of the numbers are too lengthy. Please shorten them and try again");
                            }
                        } else {
                            setNumberBaseError("Invalid csv format. Please check the data format and try again");
                        }
                    } else {
                        numberObj = { "msisdn": "", "name": "" };
                    }
                }
            } else {
                setNumberBaseError("Invalid csv format. Please check the data format and try again");
            }
            // console.log(numberList);
            return numberObj;
        });

        let filteredArray = arrayData.filter(function (value: any) {
            if (value !== null) {
                return regexNumeric.test(value.msisdn) === true;
            }
        });

        if (arrayData.length > 0 && filteredArray.length <= 0) {
            setNumberBaseError("Invalid csv format. Please check the data format and try again")
        }

        // Remove duplicate objects
        let msisdns = arrayData.map(function (o: any) {
            if (o !== null) {
                return o.msisdn;
            }
        });

        filteredArray = filteredArray.filter((value: any, index: any) => {
            if (value !== null) {
                return !msisdns.includes(value.msisdn, index + 1)
            }
        })

        // Remove null values
        filteredArray = filteredArray.filter(function (el: any) {
            return el != null;
        });

        // Remove duplicate objects
        filteredArray = filteredArray.filter(function (value: any, index: any, array: any) {
            return array.indexOf(value) == index;
        });

        let sentimentData = newSentimentData;

        if (numberBaseError === "") {
            sentimentData.numberBase = filteredArray;

            setNewSentimentData(sentimentData);
            setNumberBaseError('');
            setNumberBaseLabel(fileInfo.name);
            setNumberListLength(numberList.length);
            setDropdownSelected(true);
        } else {

            sentimentData.numberBase = [];
            setNewSentimentData(sentimentData);
            setNumberBaseLabel(fileInfo.name);
            setNumberListLength(0);
            setDropdownSelected(true);

        }
    }

    useEffect(() => {
        // validator.showMessageFor('Number base name');
        // forceUpdate();
    }, [numberBaseName])

    useEffect(() => {
        if (sentimentNumberBase === "NEW_NUMBER_BASE") {
            let sentimentData = newSentimentData;
            sentimentData.existingNumberBase = '';
            setNewSentimentData(sentimentData);
            setExistingNumberBaseDisabled(true);
            setNewNumberBaseDisabled(false);
            setNumberBaseNameDisabled(false);
        } else {
            let sentimentData = newSentimentData;
            sentimentData.numberBase = [];
            setNewSentimentData(sentimentData);
            setExistingNumberBaseDisabled(false);
            setNewNumberBaseDisabled(true);
            setNumberBaseNameDisabled(true);
            setNumberBaseLabel('Select CSV');
        }

    }, [sentimentNumberBase])

    useEffect(() => {
        if (userDetails) {
            if (userDetails.OwnedEnterprises && userDetails.OwnedEnterprises.length > 0) {
                setEnterpriseName(userDetails.OwnedEnterprises[0].Enterprise.entName);
                setEnterpiseOwnerNumber(userDetails.OwnedEnterprises[0].Enterprise.ownerMobile)
            }
        }
    }, [userDetails])

    useEffect(() => {
        setTenantNumberBases(numberList);
    }, [numberList])

    if (AuthHandler.isAuthorized(auth, 'add-new-sentiment') && userDetails !== null) {
        if (userDetails) {
            return (
                <React.Fragment>
                    <div className="main-content main-spacer-x-y">
                        <PageHeaderStatic
                            page={'create'}
                        />
                        <div className="card added-app-thumbnnail__wrapper">
                            <div
                                className="added-app-thumbnail__inner"
                                style={{
                                    backgroundImage: `url(${(singleAppDetails && singleAppDetails.widgetDetails !== null) ? singleAppDetails.widgetDetails.leftImage : ""})`
                                }}
                            ></div>
                        </div>
                        <div className="card panel content-holder-panels added-app-form__wrapper">
                            <div className="panel-header">
                                <div className="panel-header-content__wrapper">
                                    <h4 className="panel-header-title">Create a Sentiment</h4>
                                </div>
                            </div>
                            <div className="panel-content">
                                <div className="wiz-content-form__wrapper">
                                    <p>
                                        {(singleAppDetails && singleAppDetails.widgetDetails !== null) ? singleAppDetails.widgetDetails.description : ""}
                                    </p>
                                    <br />
                                    <div className="form-group__wrapper">
                                        <div className="form-group">
                                            <div className="form-element__wrapper mb-3">
                                                <label htmlFor="" className="form-label">
                                                    SMS sender name<span aria-label="required"></span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="tile"
                                                    className="form-control"
                                                    value={enterpriseName}
                                                    placeholder="SMS sender name"
                                                    disabled={true}
                                                />
                                            </div>
                                            {renderOwnersNumber()}
                                            <div className="form-element__wrapper mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Sentiment Name<span aria-label="required"></span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="tile"
                                                    className="form-control"
                                                    value={sentimentName}
                                                    placeholder="Name of the sentiment"
                                                    onChange={onSentimentNameChange}
                                                    disabled={routePath == "sentiment-update"}
                                                />
                                                <div
                                                    className="validation invalid-feedback">{validator.message('sentiment name', sentimentName, ['required', 'alpha_num_dash_space', { max: 100 }])}</div>
                                            </div>
                                            <div className="form-element__wrapper mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Select sentiment date-time<span aria-label="required"></span>
                                                </label>
                                                <div className="inner-multiple-feature-list-element__mc-wrapper horizontal">
                                                    <div className="form-check mb-4">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="now"
                                                            id="radio1"
                                                            value="now"
                                                            onChange={onChangeScheduleType}
                                                            checked={scheduleType === "now"}
                                                            disabled={routePath == "sentiment-update"}
                                                        />&nbsp;
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="flexCheckDefault"
                                                        >
                                                            Start Now
                                                        </label>
                                                    </div>
                                                    <div className="form-check mb-4">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="schedule"
                                                            id="radio1"
                                                            value="schedule"
                                                            // value={JSON.stringify(subWidget)}
                                                            onChange={onChangeScheduleType}
                                                            checked={scheduleType === "schedule"}
                                                            disabled={routePath == "sentiment-update"}
                                                        />&nbsp;
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="flexCheckDefault"
                                                        >
                                                            Schedule
                                                        </label>
                                                    </div>
                                                </div>
                                                {scheduleType === "now" ? <div className="form-group">
                                                    <div className="form-element__wrapper mb-3">
                                                        <label htmlFor="" className="form-label">
                                                            End date/time<span aria-label="required"></span>
                                                        </label>
                                                        {(date && date != '') ? <DatePicker
                                                            disabled={fieldDisabled || routePath == "sentiment-update"}
                                                            className="gx-mb-3 gx-w-100"
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            style={{ width: "100%" }}
                                                            defaultValue={dayjs(date)}
                                                            disabledDate={(current) => {
                                                                return current && current.valueOf() < Date.now();
                                                            }}
                                                            showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
                                                            onChange={onChangeDate}
                                                        /> : <DatePicker
                                                            disabled={fieldDisabled || routePath == "sentiment-update"}
                                                            className="gx-mb-3 gx-w-100"
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            style={{ width: "100%" }}
                                                            disabledDate={(current) => {
                                                                return current && current.valueOf() < Date.now();
                                                            }}
                                                            showTime={{ defaultValue: dayjs('00:00:00', 'HH:mm:ss') }}
                                                            onChange={onChangeDate}
                                                        />}
                                                        <div
                                                            className="validation invalid-feedback">{validator.message('end date', date, 'required')}</div>
                                                    </div>
                                                </div> : scheduleType === "schedule" ? <div className="form-group">
                                                    <div className="form-element__wrapper mb-3">
                                                        <label htmlFor="" className="form-label">
                                                            Start - End date/time<span aria-label="required"></span>
                                                        </label>
                                                        {(dateRange && dateRange.length > 0) ? <RangePicker
                                                            disabled={[routePath == "sentiment-update", fieldDisabled]}
                                                            className="gx-mb-3 gx-w-100"
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            style={{ width: "100%" }}
                                                            value={[dayjs(dateRange[0]), dayjs(dateRange[1])]}
                                                            disabledDate={(current) => {
                                                                return dayjs().add(-1, 'days') >= current
                                                            }}
                                                            showTime={{
                                                                defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
                                                            }}
                                                            onChange={onChangeDateRange}
                                                        /> : <RangePicker
                                                            disabled={[routePath == "sentiment-update", fieldDisabled]}
                                                            className="gx-mb-3 gx-w-100"
                                                            format="YYYY-MM-DD HH:mm:ss"
                                                            style={{ width: "100%" }}
                                                            disabledDate={(current) => {
                                                                return dayjs().add(-1, 'days') >= current
                                                            }}
                                                            showTime={{
                                                                defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
                                                            }}
                                                            onChange={onChangeDateRange}
                                                        />}
                                                        <div
                                                            className="validation invalid-feedback">{validator.message('end date', dateRange, 'required')}</div>
                                                    </div>
                                                </div> : <></>}
                                            </div>
                                            {routePath !== "sentiment-update" && <NumberbaseInput
                                                mainLabel={"Select number base"}
                                                numberBase={sentimentNumberBase}
                                                newNumberBase={newNumberBase}
                                                onSelectNumberBase={onSelectNumberBase}
                                                existingNumberBase={existingNumberBase}
                                                numberBaseName={numberBaseName}
                                                onNumberbaseNameChange={onNumberbaseNameChange}
                                                numberBaseNameDisabled={numberBaseNameDisabled}
                                                numberBaseNameError={validator.message('Number base name', numberBaseName, 'required|max:30')}
                                                inputLoading={inputLoading}
                                                onChangeFile={onChangeFile}
                                                numberBaseLabel={numberBaseLabel}
                                                newNumberBaseDisabled={newNumberBaseDisabled}
                                                numberUploadError={""}
                                                onSelectExistingNumberBase={onSelectExistingNumberBase}
                                                existingNumberBaseDisabled={existingNumberBaseDisabled}
                                                tenantNumberBases={tenantNumberBases}
                                                numberBaseError={numberBaseError}
                                                all_operators={false}
                                            />}
                                            <br></br>
                                            {routePath == "sentiment-update" && <div className="form-element__wrapper mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Number Base Name<span aria-label="required"></span>
                                                </label>
                                                <input
                                                    type="text"
                                                    id="tile"
                                                    className="form-control"
                                                    value={numberBaseName}
                                                    placeholder="Name of the sentiment"
                                                    disabled={routePath == "sentiment-update"}
                                                />
                                            </div>}
                                            {routePath !== "sentiment-update" && <div className="form-element__wrapper mb-3">
                                                <label htmlFor="" className="form-label">
                                                    Select the mask<span aria-label="required"></span>
                                                </label>
                                                <div className="icon-inside right">
                                                    <select
                                                        className="form-control"
                                                        onChange={onSelectMask}
                                                        value={seletedMask} disabled={routePath == "sentiment-update"}>
                                                        <option selected disabled>Select the mask</option>
                                                        {renderMaskList()}
                                                    </select>
                                                </div>
                                            </div>}

                                            {renderQuestions()}
                                            {routePath !== "sentiment-update" && <div className="form-group__wrapper">
                                                <div className="form-group">
                                                    <div className="form-element__wrapper mb-3">
                                                        <input className="form-check-input" type="checkbox"
                                                            checked={termsAndConditions}
                                                            id="terms-acceptence"
                                                            onChange={onConfirmationTerms} />&nbsp;&nbsp;
                                                        <label className="form-check-label"
                                                            htmlFor="terms-acceptence">
                                                            I agree to <a onClick={onShowTnC}>Terms and conditions</a>
                                                        </label>
                                                    </div>
                                                    <div className="validation invalid-feedback">{tncError}</div>
                                                </div>
                                            </div>}
                                            {routePath == "sentiment-update" && <div className="form-element__wrapper mb-3">

                                                <div className="inner-multiple-feature-list-element__mc-wrapper horizontal">
                                                    <div className="form-check mb-4">
                                                        <label htmlFor="" className="form-check-label">
                                                            Sentiment Status - {sentimentStatus ? sentimentStatus : ""}<span aria-label="required"></span>
                                                        </label>
                                                    </div>
                                                    <div className="form-check mb-4">
                                                        <Switch
                                                            onChange={onChangeStatus}
                                                            className="sentiment-toggle"
                                                            checked={sentimentStatus === 'Active' ? true : sentimentStatus === 'Running' ? true : false}
                                                            disabled={statusValue === 'Active' ? false : statusValue === 'Running' ? false : true}
                                                            defaultChecked />
                                                    </div>
                                                </div>
                                            </div>}

                                            <div className="panel-bottom-btn__wrapper">
                                                <button className="btn btn-secondary" onClick={() => { navigate(-1) }}>Cancel</button>
                                                {renderSubmitButton()}
                                            </div>
                                            <Modal
                                                title="Terms and Conditions"
                                                open={showTnC}
                                                onCancel={onHideTnC}
                                                footer={null}
                                                style={{ minWidth: 800 }}
                                            >
                                                <div style={{ maxHeight: '350px', overflowY: "auto" }}>
                                                    <div className="scroller__wrapper">
                                                        <div className="terms__content">
                                                            <p><b>{termsAndConditions}</b></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Modal>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <div className="section__wrapper">
                    <div className="empty-state-new-action__wrapper">
                        <div className="new-action-content__wrapper">
                            <h4 className="sub">Oops, something went wrong!</h4>
                        </div>
                    </div>
                </div>
            );
        }
    } else return (<React.Fragment></React.Fragment>);

}

export default AddNewSentiment;